import { ThemeConfig } from 'antd';

/**
 * Custom Ant Design theme configuration
 */

export const theme: ThemeConfig = {
  token: {
    colorPrimary: '#F97316',
    colorText: '#171717',
    fontFamily: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue'`,
  },
  components: {
    Menu: {
      itemBorderRadius: 6,
      darkItemSelectedBg: 'rgba(255, 255, 255, 0.2)',
      darkItemColor: 'rgba(255, 255, 255, 0.8)',
      darkItemSelectedColor: '#FB923C',
      darkItemHoverBg: 'rgba(255, 255, 255, 0.2)',
      darkItemHoverColor: 'rgba(255, 255, 255, 0.8)',
    },
    Table: {
      rowSelectedBg: '#fedfb9',
      rowHoverBg: '#fedfb9',
      headerBg: '#f0f0f0',
      headerSortHoverBg: '#fafafa',
    },
  },
};
